import { IdNameInterface, LabelValueInterface } from "../../models/common.models";

export const convertIdNameToLabelValue = (data: IdNameInterface): LabelValueInterface => {
    return  {
        label: data.name,
        value: data.id
    };
}

